import './zoom.scss';
export function imageZoom() {
    return {
        x: 0,
        y: 0,
        mouseOver(target) {
            const lens = target.nextElementSibling;
            lens.classList.add('show');
            // load the image lazily the first time it is shown
            const image = lens.firstElementChild;
            if (!image.src) {
                lens.classList.add('loading');
                image.src = image.dataset.src;
                image.onload = () => {
                    lens.classList.remove('loading');
                    setImageSize(image, target);
                    this.reposition(target);
                };
            }
        },
        mouseOut(image) {
            const lens = image.nextElementSibling;
            lens.classList.remove('show');
        },
        mouseMove(event) {
            this.x = event.clientX;
            this.y = event.clientY;
            const img = event.target;
            this.reposition(img);
        },
        reposition(img) {
            const lens = img.nextElementSibling;
            const lensImg = lens.firstElementChild;
            const boundingRect = img.getBoundingClientRect();
            const posX = this.x - boundingRect.x;
            const posY = this.y - boundingRect.y;
            const halfWidth = lens.offsetWidth / 2;
            const halfHeight = lens.offsetHeight / 2;
            lens.style.left = `${posX - halfWidth}px`;
            lens.style.top = `${posY - halfHeight}px`;
            const tx = halfWidth - posX / img.offsetWidth * lensImg.offsetWidth;
            const ty = halfHeight - posY / img.offsetHeight * lensImg.offsetHeight;
            lensImg.style.transform = `translate(${tx}px, ${ty}px)`;
        },
    };
}
function setImageSize(image, target) {
    const width = Math.min(image.naturalWidth, 1000);
    image.style.height = width * (target.offsetHeight / target.offsetWidth) + "px";
    image.style.width = width + "px";
}
